<template lang="html">
    <div class="container renew-consent-success">
        <div class="renew-consent-success__box">
            <img src="/img/save_folder.svg" alt="save folder">
            <h1 class="renew-consent-success__title fw-bold my-3">Thank you for your time!</h1>
            <p class="renew-consent-success__paragraph">The process has been successfully completed and your<br /> consent has been renewed correctly. You may exit this page.</p>
        </div>
    </div>
</template>
<script>

export default {
    name:'Success'
}
</script>
<style scoped lang="scss">
    .renew-consent-success{
        height: calc(100vh - 7rem);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &__box{
            display: contents;
        }

        &__title {
            color:var(--color-main);
            font-size: 3.2rem;
            text-align: center;
        }

        &__paragraph {
            text-align: center;
            font-size: 1.6rem;
            color: var(--color-6b6f70);
        }
        
    }

</style>